module.exports = __webpack_public_path__ + "img/vertical_4_7_7016.98b0063e.png";